// SEO optimallash — xizmat sahifasi kontenti (Innobek)

const uz = {
    meta: {
        title: "SEO optimallash — saytni Google qidiruvida yuqoriga chiqarish",
        description:
            "SEO optimallash xizmati: texnik audit, semantik yadro, kontent va tashqi nufuz. O'zbek va rus tilidagi so'rovlar, Yandex bilan ish. Narx oyiga 6 000 000 so'mdan.",
        keywords: [
            "SEO optimallash",
            "SEO xizmati Toshkent",
            "saytni Google'da ko'tarish",
            "SEO narxi",
            "SEO audit",
            "organik trafik",
            "semantik yadro",
            "Core Web Vitals",
            "mahalliy SEO",
        ],
    },
    hero: {
        eyebrow: "SEO / Qidiruv optimizatsiyasi",
        h1: "SEO optimallash — Google qidiruvida yuqori o'rinlar",
        lead:
            "Reklama o'chsa, tashrif ham o'chadi. SEO boshqacha ishlaydi: bugun bajarilgan ish bir yildan keyin ham mijoz keltirib turadi. Biz saytingizni odamlar haqiqatda yozadigan so'rovlar bo'yicha yuqoriga olib chiqamiz — va buni raqamlar bilan ko'rsatamiz.",
        ctaPrimary: "Bepul SEO audit olish",
        ctaSecondary: "Jarayonni ko'rish",
        proof: [
            "O'zbek va rus tilidagi so'rovlar",
            "Google va Yandex bilan parallel ish",
            "Har oy ochiq hisobot va pozitsiya jadvali",
            "Kafolat emas — reja va raqam",
        ],
    },
    intro: {
        h: "SEO optimallash nima va u qanday natija beradi?",
        p: [
            "SEO optimallash — saytni qidiruv tizimlari natijalarida yuqoriga chiqarish uchun qilinadigan texnik, kontent va nufuz ishlari majmuasi. Kontekst reklamadan farqi shundaki, bu yerda bosish uchun pul to'lamaysiz. Sahifa bir marta yuqoriga chiqsa, u oylar davomida bepul tashrif keltiradi.",
            "Bugungi SEO uchta ustunga tayanadi. Birinchisi — texnik holat: sayt tez ochilishi, mobil qurilmada to'g'ri ko'rinishi, indekslanishga to'sqinlik qiladigan xatolari bo'lmasligi kerak. Ikkinchisi — kontent: sahifa foydalanuvchi savoliga aniq javob berishi shart. Uchinchisi — tashqi nufuz: boshqa saytlar sizga havola berishi va kompaniya nomi internetda eslatilishi.",
            "Endi eng muhim gap. SEO tez natija bermaydi. Birinchi sezilarli o'zgarishlar odatda 2–3 oydan oldin ko'rinmaydi, jiddiy o'sish esa 5–9 oy oralig'ida keladi. Kim sizga «bir oyda birinchi o'ringa chiqaramiz» desa — u yo bilmasdan gapiryapti, yo ataylab aldayapti. Uchinchi variant ham bor: sayt uchun xavfli usullar ishlatiladi va bir necha oydan keyin sayt filtrga tushadi.",
            "Biz shuning uchun ishni boshidanoq ochiq olib boramiz. Birinchi oyda pozitsiya emas, texnik ko'rsatkichlar va indekslangan sahifalar soni o'zgaradi. Ikkinchi–uchinchi oyda past raqobatli so'rovlar bo'yicha birinchi natijalar chiqadi. To'rtinchi oydan boshlab trafik grafigi sezilarli ko'tarila boshlaydi. Har oy sizga nima qilinganini va nima o'zgarganini raqam bilan ko'rsatamiz — pozitsiya jadvali, trafik grafigi va ariza soni bitta hisobotda bo'ladi.",
            "O'zbekiston bozorining o'z xususiyati bor: bitta biznes uchun so'rovlar kamida ikki tilda yoziladi — o'zbekcha va ruscha. Ko'p kompaniyalar faqat bittasi bilan ishlaydi va trafikning yarmini raqobatchiga beradi. Bundan tashqari, ayrim sohalarda Yandex ulushi hali ham sezilarli. Biz ikkala tizimni ham hisobga olamiz.",
        ],
    },
    definition: {
        term: "SEO optimallash nima?",
        text:
            "SEO optimallash — saytning texnik holati, kontenti va tashqi nufuzini yaxshilash orqali uni Google va Yandex qidiruv natijalarida yuqoriga chiqarish va bepul mijoz oqimini yaratish jarayoni. Birinchi natija odatda 2–3 oydan keyin ko'rinadi.",
    },
    included: {
        eyebrow: "Nimalar kiradi",
        h: "SEO ishlariga nimalar kiradi",
        sub: "Quyidagi ro'yxatdan saytingizga keraklilari tanlanadi — reja auditdan keyin individual tuziladi.",
        items: [
            "Texnik audit: indekslash, robots.txt, sitemap, dublikat sahifalar, 404 va redirektlar",
            "Semantik yadro: o'zbek va rus tilidagi so'rovlarni yig'ish, chastota va niyat bo'yicha guruhlash",
            "Raqobatchilar tahlili: ular qaysi sahifalar bilan qaysi so'rovlardan trafik olmoqda",
            "Sayt tuzilmasi va ichki bog'lanish sxemasi",
            "Title, description va sarlavhalarni har bir sahifa uchun alohida yozish",
            "Yangi kontent yozish va mavjud matnlarni qayta ishlash",
            "Tezlik va Core Web Vitals: LCP, INP, CLS ko'rsatkichlarini yaxshilash",
            "Schema.org belgilash: Organization, Service, FAQ, Article, LocalBusiness",
            "Rasm optimizatsiyasi: WebP formati, alt matnlar, hajmni kamaytirish",
            "Ko'p tilli SEO: hreflang teglari, uz/ru versiyalarini to'g'ri bog'lash",
            "Mahalliy SEO va Google Business profilini qidiruv bilan bog'lash",
            "Yandex Webmaster va Google Search Console sozlash, xatolarni kuzatish",
            "Tashqi havolalar va kompaniya eslatmalari ustida ish",
            "Pozitsiyalarni haftalik kuzatish va oylik hisobot",
        ],
    },
    benefits: {
        eyebrow: "Nega kerak",
        h: "SEO biznesga nima beradi",
        sub: "Reklama — ijaraga olingan joy, SEO — o'zingizniki. Farqi quyida.",
        items: [
            {
                t: "Trafik to'xtamaydi",
                d: "Reklama byudjeti tugagan kuni tashriflar nolga tushadi. SEO orqali olingan pozitsiya esa ishni to'xtatgandan keyin ham bir necha oy ishlab turadi.",
            },
            {
                t: "Bosish uchun to'lov yo'q",
                d: "Har bir tashrif uchun alohida pul ketmaydi. Trafik o'sgani sari bitta mijozni jalb qilish narxi pasayadi — kontekst reklamada esa aksincha bo'ladi.",
            },
            {
                t: "Ishonch darajasi yuqori",
                d: "Foydalanuvchilarning katta qismi «Reklama» yorlig'i turgan natijani ongli ravishda o'tkazib yuboradi. Organik birinchi o'rin obro' beradi.",
            },
            {
                t: "Sotib olishga tayyor mijoz",
                d: "«Toshkentda CRM tizimi narxi» deb qidirayotgan odam allaqachon tanlash bosqichida. Bunday so'rovdan kelgan ariza banner reklamadan kelganidan ancha issiq.",
            },
            {
                t: "Har bir sahifa alohida ishlaydi",
                d: "Xizmat sahifalari, katalog bo'limlari va blog maqolalari o'z so'rovlari bo'yicha chiqadi. Sayt kattalashgani sari kirish nuqtalari ko'payadi.",
            },
            {
                t: "Ikki tilda ikki barobar qamrov",
                d: "O'zbek va rus tilidagi so'rovlarni parallel qamrab olsangiz, bir xil mehnat bilan auditoriyangiz kengayadi. Ko'pchilik buni qilmaydi.",
            },
            {
                t: "Pul saytda qoladi",
                d: "Yozilgan kontent, tuzatilgan texnik xatolar va olingan havolalar sizniki bo'lib qoladi. Bu — o'chib ketadigan xarajat emas, aktiv.",
            },
        ],
    },
    audience: {
        eyebrow: "Kimlarga mos",
        h: "SEO kimlar uchun ishlaydi",
        sub: "Mahsuloti yoki xizmati Google va Yandex'da qidiriladigan bizneslar uchun.",
        items: [
            {
                t: "Xizmat ko'rsatuvchi kompaniyalar",
                d: "Klinika, yuridik byuro, qurilish, ta'mirlash, klining. Odamlar bu xizmatlarni aynan qidiruvdan boshlab izlaydi.",
            },
            {
                t: "Internet-do'konlar",
                d: "Har bir kategoriya va mahsulot kartochkasi alohida so'rov. Katalog qanchalik katta bo'lsa, SEO shuncha ko'p foyda beradi.",
            },
            {
                t: "B2B va ishlab chiqarish",
                d: "Qaror qabul qilish sikli uzun sohalarda mijoz avval o'qiydi, taqqoslaydi, keyin murojaat qiladi. Kontent aynan shu bosqichda ishlaydi.",
            },
            {
                t: "Reklama qimmatlashgan sohalar",
                d: "Bosish narxi ko'tarilib ketgan bo'lsa, SEO uzoq muddatda ariza tannarxini tushirishning eng ishonchli yo'li.",
            },
            {
                t: "Mahalliy bizneslar",
                d: "Salon, kafe, avtoservis, do'kon. «Yaqin atrofda» tipidagi so'rovlar va xarita natijalari orqali mijoz keladi.",
            },
            {
                t: "Yangi qurilgan saytlar",
                d: "Asosni boshidan to'g'ri qo'yish keyinchalik qayta qurishdan ancha arzon. Faqat natijani biroz uzoqroq kutasiz.",
            },
        ],
    },
    pricing: {
        eyebrow: "Narxlar",
        h: "SEO xizmati narxlari",
        sub: "Oylik abonent to'lov modeli. Audit alohida, bir martalik.",
        note:
            "Quyidagi summalar boshlang'ich narxlar. Aniq raqam bepul auditdan keyin beriladi: saytning hozirgi holati, raqobat darajasi, sahifalar soni va kerakli kontent hajmi hisoblanadi. SEO'ni kamida 6 oylik ish sifatida rejalashtiring — qisqaroq muddatda pul sarflanadi, natija esa ulgurmaydi. Telefon: +998 90 954 12 62.",
        tiers: [
            {
                name: "Audit",
                tagline: "Bir martalik tahlil va yo'l xaritasi",
                price: "3 500 000 so'm",
                priceNote: "bir martalik",
                term: "7–10 ish kuni",
                best: "Saytdagi muammolarni bilish va ularni o'z jamoangiz bilan tuzatish uchun",
                features: [
                    "To'liq texnik audit: indekslash, tezlik, xatolar, mobil moslashuv",
                    "Semantik yadro: 300–600 so'rov, o'zbek va rus tilida",
                    "5 ta asosiy raqobatchi tahlili",
                    "Sayt tuzilmasi bo'yicha aniq tavsiyalar",
                    "Kontent uchun texnik topshiriq",
                    "Ustuvorlik bo'yicha tartiblangan vazifalar ro'yxati",
                    "Hisobotni tushuntirish uchun 1 soatlik uchrashuv",
                ],
            },
            {
                name: "Doimiy SEO",
                tagline: "Oylik ish va barqaror o'sish",
                price: "6 000 000 so'm",
                priceNote: "oyiga, kamida 6 oy",
                term: "Oylik abonent to'lov",
                best: "Qidiruvdan doimiy ariza oqimini yo'lga qo'ymoqchi bo'lgan o'rta biznes uchun",
                featured: true,
                features: [
                    "Audit paketidagi barcha ishlar birinchi oyda",
                    "Texnik xatolarni bosqichma-bosqich tuzatish",
                    "Oyiga 4–6 ta sahifa yoki maqola matni",
                    "Meta teglar, sarlavhalar va ichki bog'lanish ustida doimiy ish",
                    "Core Web Vitals optimizatsiyasi",
                    "Schema.org belgilash va boy natijalar",
                    "Google Business profili bilan bog'lash",
                    "Yandex Webmaster sozlash va kuzatuv",
                    "Oylik hisobot: pozitsiya, trafik, ariza raqamlari",
                ],
            },
            {
                name: "Kompleks",
                tagline: "SEO + kontent + tashqi nufuz",
                price: "12 000 000 so'm",
                priceNote: "oyiga, kamida 6 oy",
                term: "Oylik abonent to'lov",
                best: "Raqobati yuqori sohalar, katta kataloglar va ko'p tilli saytlar uchun",
                features: [
                    "Doimiy SEO paketidagi barcha ishlar",
                    "Oyiga 10–14 ta matn va kengaytirilgan blog rejasi",
                    "Tashqi havolalar bilan ish va kompaniya eslatmalari",
                    "Katta kataloglar uchun sahifalarni ommaviy optimallashtirish",
                    "Uch tilli SEO (uz / ru / en) va hreflang sxemasi",
                    "Konversiya tahlili: trafik arizaga aylanyaptimi",
                    "Raqobatchilarni oylik monitoring",
                    "Shaxsiy SEO menejeri va haftalik aloqa",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Jarayon",
        h: "SEO qanday olib boriladi",
        sub: "Birinchi o'zgarishlar 2–3 oyda, sezilarli o'sish 5–9 oyda ko'rinadi. Bundan tezroq va'da beradiganlarga ishonmang.",
        steps: [
            {
                t: "Bepul dastlabki audit",
                time: "3–5 kun",
                d: "Saytning texnik holati, mavjud pozitsiyalari va raqobatchilari tekshiriladi. Sizga muammolar ro'yxati va taxminiy reja beriladi — majburiyatsiz.",
            },
            {
                t: "Semantik yadro",
                time: "1–2 hafta",
                d: "Odamlar aynan nima deb qidirayotganini yig'amiz. So'rovlar ikki tilda to'planadi, niyat bo'yicha ajratiladi va sahifalarga taqsimlanadi.",
            },
            {
                t: "Texnik tuzatishlar",
                time: "2–6 hafta",
                d: "Indekslash, tezlik, mobil moslashuv, dublikatlar, belgilash. Bu bosqichsiz keyingi ishlarning samarasi yarmiga tushadi.",
            },
            {
                t: "Sahifalar va kontent",
                time: "davomiy",
                d: "Mavjud sahifalar qayta yoziladi, yangi sahifalar va maqolalar chiqadi. Har biri o'z so'rovlar guruhi ostida ishlaydi.",
            },
            {
                t: "Mahalliy signallar",
                time: "2–4 hafta",
                d: "Google Business profili, xaritadagi ma'lumot, NAP birxilligi va mahalliy katalogdagi yozuvlar tartibga solinadi.",
            },
            {
                t: "Tashqi nufuz",
                time: "davomiy",
                d: "Sifatli saytlardan havolalar olinadi, kompaniya haqidagi eslatmalar ko'paytiriladi. Sotib olingan arzon havolalar ishlatilmaydi.",
            },
            {
                t: "O'lchash va tuzatish",
                time: "har oy",
                d: "Pozitsiya, trafik va ariza raqamlari solishtiriladi. Ishlamagan gipoteza olib tashlanadi, ishlagani kengaytiriladi.",
            },
        ],
    },
    samples: {
        eyebrow: "Namunalar",
        h: "Biz qidiruvga tayyorlagan saytlar",
        sub: "Quyidagi loyihalar boshidan SEO talablari hisobga olingan holda qurilgan.",
        cta: "Barcha loyihalarni ko'rish",
        slugs: ["mountain-and-sea", "global-building-group", "ipsum-pathology", "cleanza"],
    },
    faq: {
        eyebrow: "Savol-javob",
        h: "SEO bo'yicha ko'p beriladigan savollar",
        sub: "Eng ko'p so'raladigan savollarga to'g'ridan-to'g'ri javoblar.",
        items: [
            {
                q: "SEO optimallash qancha turadi?",
                a: "Innobek'da bir martalik audit 3 500 000 so'm, doimiy SEO oyiga 6 000 000 so'mdan, kompleks paket 12 000 000 so'mdan boshlanadi. Aniq summa saytning hajmi, soha raqobati va kerakli kontent miqdoriga bog'liq. Vizitka saytni ko'tarish bilan 5000 mahsulotli katalogni ko'tarish o'rtasida mehnat farqi o'nlab barobar.",
            },
            {
                q: "SEO natijasi qancha vaqtda ko'rinadi?",
                a: "Birinchi o'zgarishlar 2–3 oyda ko'rinadi: texnik ko'rsatkichlar yaxshilanadi, past raqobatli so'rovlar bo'yicha pozitsiyalar paydo bo'ladi va indekslangan sahifalar soni ortadi. Sezilarli trafik o'sishi esa 5–9 oy oralig'ida keladi. Raqobati yuqori sohalarda bu muddat bir yilgacha cho'ziladi. Birinchi oyda pozitsiya o'zgarishini kutmang — bu mutlaqo normal holat va biz buni shartnoma imzolashdan oldin ochiq aytamiz.",
            },
            {
                q: "Birinchi o'rinni kafolatlaysizmi?",
                a: "Yo'q. Va kafolat bergan har qanday kompaniyadan uzoqroq turing. Google reyting algoritmini hech bir agentlik boshqara olmaydi. Biz kafolatlaydigan narsa — bajariladigan ish hajmi, uning sifati va har oy ochiq raqamlar. Amaliy maqsad shunday qo'yiladi: «shu 25 so'rov bo'yicha oltinchi oyga birinchi o'nlikka chiqish».",
            },
            {
                q: "Bir oyda birinchi o'ringa chiqarish mumkinmi?",
                a: "Deyarli hech qachon. Istisno — raqobati nolga yaqin, juda tor so'rovlar, masalan kompaniyangizning o'z nomi. Haqiqiy tijorat so'rovlari bo'yicha bir oy Google'ning saytga ishonchi shakllanishi uchun ham yetmaydi. Bunday va'da bergan agentlik yo yolg'onchi, yo sizni xavfli usullar bilan filtrga tiqmoqchi.",
            },
            {
                q: "O'zbek tilida SEO qilish kerakmi yoki rus tilida?",
                a: "Ikkalasida ham. O'zbekistonda bitta xizmat uchun so'rovlar ikki tilda yoziladi va ularning hajmi soha bo'yicha keskin farq qiladi. Tibbiyot va ta'limda o'zbekcha so'rovlar ko'proq, IT va B2B'da ruscha ustunlik qiladi. Faqat bittasi bilan ishlash — trafikning yarmini raqobatchiga sovg'a qilish.",
            },
            {
                q: "Yandex bilan ham ishlaysizmi?",
                a: "Ha. O'zbekistonda Google ustun, lekin ayrim sohalarda va ruszabon auditoriya orasida Yandex ulushi hali sezilarli. Yandex Webmaster'ni sozlaymiz, sayt kartasini yuboramiz, mintaqani belgilaymiz va indekslash xatolarini kuzatamiz. Yaxshi yangilik shundaki, texnik va kontent ishlarining katta qismi ikkala tizim uchun bir xil foyda beradi — alohida byudjet talab qilinmaydi.",
            },
            {
                q: "Reklama qilsam SEO kerak emasmi?",
                a: "Ular bir-birini almashtirmaydi, to'ldiradi. Google Ads bugundan ariza beradi, lekin byudjet tugashi bilan to'xtaydi. SEO sekin boshlanadi, lekin oltinchi oydan keyin ariza tannarxini sezilarli tushiradi. Ko'p mijozimiz reklamadan boshlab, parallel ravishda SEO olib boradi va vaqt o'tib reklama byudjetini kamaytiradi.",
            },
            {
                q: "Saytim yangi — SEO qilsa bo'ladimi?",
                a: "Ha, va bu eng to'g'ri vaqt. Yangi saytda tuzilmani, URL sxemasini va texnik asosni boshidan to'g'ri qurish keyinchalik qayta qilishdan ancha arzon. Yagona kamchilik — natija biroz kechroq chiqadi, chunki yangi domenga Google ishonchi shakllanishi uchun odatda 3–6 oy ketadi.",
            },
            {
                q: "Kontentni kim yozadi?",
                a: "Shartga qarab uch xil sxema bo'ladi: biz yozamiz, siz yozasiz yoki birgalikda ishlaymiz. Amalda eng yaxshi natija uchinchi variantda chiqadi — soha bilimi, faktlar va real misollar sizdan, tuzilma hamda SEO talablariga moslash bizdan. Har bir matn chop etishdan oldin sizga tasdiqlashga yuboriladi, tuzatishlaringiz kiritiladi va shundan keyin saytga joylanadi.",
            },
            {
                q: "Shartnomani to'xtatsam, pozitsiyalar yo'qoladimi?",
                a: "Darhol emas. Bajarilgan ishning hammasi saytingizda qoladi: kontent, texnik tuzatishlar, Schema.org belgilash va olingan havolalar sizniki bo'lib qolaveradi. Lekin raqobatchilar ishlashni to'xtatmaydi va Google algoritmi muntazam yangilanadi, shuning uchun taxminan 4–8 oy ichida pozitsiyalar asta-sekin pasayishi mumkin. Yiqilish tezligi soha raqobatiga bog'liq.",
            },
            {
                q: "Bepul audit haqiqatan bepulmi?",
                a: "Dastlabki audit — ha, haqiqatan bepul. Unda saytning asosiy texnik muammolari, taxminiy so'rovlar ro'yxati va umumiy reja bo'ladi, hech qanday majburiyatsiz. To'liq 3 500 000 so'mlik audit esa ancha chuqurroq: to'liq semantik yadro, beshta raqobatchi tahlili va dasturchi bajarishi uchun tayyor texnik topshiriq bilan keladi.",
            },
        ],
    },
    cta: {
        h: "Saytingiz hozir Google'da qayerda turibdi?",
        p: "Bepul auditda hozirgi holatni ko'rsatamiz, qaysi so'rovlar bo'yicha real chiqish mumkinligini aytamiz va muddatlar bilan reja beramiz. Ortiqcha va'da bermaymiz.",
        button: "Bepul SEO audit olish",
        secondary: "+998 90 954 12 62",
    },
    images: [
        {
            src: "/assets/img/blog/web-seo.webp",
            alt: "Google qidiruv natijasi va PageSpeed ko'rsatkichlari — SEO optimallash natijasi",
            caption: "Qidiruv natijasidagi o'rin va sayt tezligi bir-biriga bog'liq: sekin sayt yuqoriga chiqmaydi.",
        },
        {
            src: "/assets/img/services/seo-semantika.webp",
            alt: "O'zbek va rus tilidagi kalit so'zlar jadvali — semantik yadro tuzish bosqichi",
            caption: "Semantik yadro ikki tilda yig'iladi va so'rov niyati bo'yicha guruhlanadi.",
            prompt:
                "Clean desktop screenshot-style illustration of a keyword research spreadsheet with two language columns (Uzbek Latin and Russian Cyrillic), search volume and difficulty columns, soft blue accent highlights, light UI, no logos, high detail, 16:9",
        },
        {
            src: "/assets/img/services/seo-texnik-audit.webp",
            alt: "Saytning texnik SEO auditi: indekslash xatolari va Core Web Vitals hisoboti",
            caption: "Texnik audit — kontent yozishdan oldingi majburiy bosqich.",
            prompt:
                "Modern analytics dashboard showing technical SEO audit results: crawl errors list, indexation chart, Core Web Vitals gauges for LCP INP CLS in green and amber, minimal light interface, no brand logos, 16:9",
        },
        {
            src: "/assets/img/services/seo-osish-grafigi.webp",
            alt: "Organik trafikning olti oylik o'sish grafigi — SEO natijasi dinamikasi",
            caption: "Tipik dinamika: birinchi ikki oy tekis, keyin asta-sekin ko'tarilish.",
            prompt:
                "Line chart of organic search traffic growth over nine months, flat for the first two months then rising steadily, clean minimal analytics UI, blue gradient fill, month labels, no logos, 16:9",
        },
    ],
    related: ["google-ads", "google-business", "korporativ-saytlar", "internet-dokonlar"],
};

const ru = {
    meta: {
        title: "SEO-оптимизация — вывод сайта в топ Google",
        description:
            "SEO-оптимизация сайта: технический аудит, семантическое ядро, контент и внешний вес. Запросы на узбекском и русском, работа с Яндексом. Цена — от 6 000 000 сум в месяц.",
        keywords: [
            "SEO-оптимизация",
            "SEO-продвижение Ташкент",
            "вывод сайта в топ Google",
            "стоимость SEO",
            "SEO-аудит",
            "органический трафик",
            "семантическое ядро",
            "Core Web Vitals",
            "локальное SEO",
        ],
    },
    hero: {
        eyebrow: "SEO / Поисковая оптимизация",
        h1: "SEO-оптимизация — высокие позиции в поиске Google",
        lead:
            "Выключили рекламу — выключился и трафик. SEO работает иначе: работа, сделанная сегодня, приводит клиентов и через год. Мы выводим сайт по тем запросам, которые люди действительно набирают, и показываем результат цифрами.",
        ctaPrimary: "Получить бесплатный SEO-аудит",
        ctaSecondary: "Посмотреть процесс",
        proof: [
            "Запросы на узбекском и русском",
            "Параллельная работа с Google и Яндексом",
            "Ежемесячный открытый отчёт и таблица позиций",
            "Не гарантии, а план и цифры",
        ],
    },
    intro: {
        h: "Что такое SEO-оптимизация и какой результат она даёт",
        p: [
            "SEO-оптимизация — это комплекс технических, контентных и репутационных работ, которые выводят сайт выше в результатах поисковых систем. Главное отличие от контекстной рекламы: вы не платите за каждый клик. Страница, однажды поднявшаяся в топ, приносит бесплатные визиты месяцами.",
            "Современное SEO держится на трёх опорах. Первая — техническое состояние: сайт должен быстро открываться, корректно отображаться на телефоне и не иметь ошибок, мешающих индексации. Вторая — контент: страница обязана точно отвечать на вопрос пользователя. Третья — внешний вес: на вас ссылаются другие сайты, а название компании упоминается в интернете.",
            "Теперь главное. SEO не даёт быстрого результата. Первые заметные сдвиги появляются не раньше 2–3 месяцев, серьёзный рост — в диапазоне 5–9 месяцев. Если вам обещают «первое место за месяц», человек либо не разбирается, либо сознательно вводит в заблуждение. Есть и третий вариант: применяются рискованные методы, и через несколько месяцев сайт попадает под фильтр.",
            "Поэтому мы с самого начала ведём работу открыто. В первый месяц меняются не позиции, а технические показатели и количество проиндексированных страниц. На втором–третьем месяце появляются первые результаты по низкоконкурентным запросам. С четвёртого месяца график трафика начинает заметно расти. Каждый месяц вы видите, что сделано и что изменилось, в цифрах.",
            "У узбекистанского рынка своя особенность: под один и тот же бизнес запросы набирают минимум на двух языках — узбекском и русском. Многие компании работают только с одним и отдают половину трафика конкурентам. Плюс в ряде ниш доля Яндекса до сих пор заметна. Мы учитываем обе системы.",
        ],
    },
    definition: {
        term: "Что такое SEO-оптимизация?",
        text:
            "SEO-оптимизация — это улучшение технического состояния, контента и внешнего веса сайта ради более высоких позиций в Google и Яндексе и постоянного потока бесплатных клиентов. Первый результат обычно виден через 2–3 месяца.",
    },
    included: {
        eyebrow: "Что входит",
        h: "Какие работы входят в SEO",
        sub: "Из списка ниже подбирается то, что нужно вашему сайту — план составляется индивидуально после аудита.",
        items: [
            "Технический аудит: индексация, robots.txt, sitemap, дубли, 404 и редиректы",
            "Семантическое ядро: сбор запросов на узбекском и русском, группировка по частоте и интенту",
            "Анализ конкурентов: какие их страницы собирают трафик и по каким запросам",
            "Структура сайта и схема внутренней перелинковки",
            "Написание title, description и заголовков под каждую страницу отдельно",
            "Создание нового контента и переработка существующих текстов",
            "Скорость и Core Web Vitals: улучшение LCP, INP и CLS",
            "Разметка Schema.org: Organization, Service, FAQ, Article, LocalBusiness",
            "Оптимизация изображений: формат WebP, alt-тексты, снижение веса",
            "Мультиязычное SEO: hreflang и корректная связка uz/ru-версий",
            "Локальное SEO и связка сайта с профилем Google Business",
            "Настройка Яндекс.Вебмастера и Google Search Console, контроль ошибок",
            "Работа с внешними ссылками и упоминаниями компании",
            "Еженедельный съём позиций и ежемесячный отчёт",
        ],
    },
    benefits: {
        eyebrow: "Зачем это нужно",
        h: "Что SEO даёт бизнесу",
        sub: "Реклама — арендованное место, SEO — собственное. Разница ниже.",
        items: [
            {
                t: "Трафик не обрывается",
                d: "Как только заканчивается рекламный бюджет, визиты падают до нуля. Позиции, полученные через SEO, продолжают работать ещё несколько месяцев после остановки работ.",
            },
            {
                t: "Нет оплаты за клик",
                d: "За каждый визит не списываются деньги. Чем больше трафика, тем ниже стоимость привлечения клиента — в контексте всё происходит ровно наоборот.",
            },
            {
                t: "Выше уровень доверия",
                d: "Значительная часть пользователей осознанно пропускает блоки с пометкой «Реклама». Первое органическое место воспринимается как признак репутации.",
            },
            {
                t: "Клиент, готовый купить",
                d: "Человек, набравший «стоимость CRM-системы в Ташкенте», уже находится на этапе выбора. Заявка с такого запроса заметно теплее, чем с баннера.",
            },
            {
                t: "Работает каждая страница",
                d: "Страницы услуг, разделы каталога и статьи блога ранжируются по своим запросам. Чем больше сайт, тем больше точек входа.",
            },
            {
                t: "Два языка — двойной охват",
                d: "Параллельный охват узбекских и русских запросов расширяет аудиторию при примерно тех же трудозатратах. Большинство конкурентов этого не делает.",
            },
            {
                t: "Вложения остаются в сайте",
                d: "Написанный контент, исправленные ошибки и полученные ссылки принадлежат вам. Это актив, а не расход, который исчезает вместе с бюджетом.",
            },
        ],
    },
    audience: {
        eyebrow: "Кому подходит",
        h: "Для кого SEO действительно работает",
        sub: "Для бизнесов, чьи товары и услуги ищут в Google и Яндексе.",
        items: [
            {
                t: "Компании сферы услуг",
                d: "Клиники, юридические бюро, строительство, ремонт, клининг. Поиск этих услуг почти всегда начинается с поисковой строки.",
            },
            {
                t: "Интернет-магазины",
                d: "Каждая категория и карточка товара — отдельный запрос. Чем больше каталог, тем сильнее отдача от SEO.",
            },
            {
                t: "B2B и производство",
                d: "В нишах с длинным циклом сделки клиент сначала читает и сравнивает, и только потом обращается. Контент работает именно на этом этапе.",
            },
            {
                t: "Ниши с дорогой рекламой",
                d: "Если стоимость клика выросла до неприемлемой, SEO — самый надёжный способ снизить стоимость заявки в долгосрочной перспективе.",
            },
            {
                t: "Локальный бизнес",
                d: "Салон, кафе, автосервис, магазин. Клиенты приходят по запросам «рядом со мной» и через результаты на карте.",
            },
            {
                t: "Новые сайты",
                d: "Заложить правильную основу сразу дешевле, чем перестраивать потом. Единственный минус — результата придётся ждать чуть дольше.",
            },
        ],
    },
    pricing: {
        eyebrow: "Цены",
        h: "Стоимость SEO-оптимизации",
        sub: "Модель — ежемесячная абонентская плата. Аудит оплачивается отдельно и один раз.",
        note:
            "Указанные суммы — стартовые. Точная цифра называется после бесплатного аудита: учитываются текущее состояние сайта, уровень конкуренции, количество страниц и нужный объём контента. Планируйте SEO минимум на 6 месяцев — на более коротком горизонте деньги потратятся, а результат не успеет сформироваться. Телефон: +998 90 954 12 62.",
        tiers: [
            {
                name: "Аудит",
                tagline: "Разовый анализ и дорожная карта",
                price: "3 500 000 сум",
                priceNote: "разово",
                term: "7–10 рабочих дней",
                best: "Тем, кто хочет понять проблемы сайта и исправить их силами своей команды",
                features: [
                    "Полный технический аудит: индексация, скорость, ошибки, мобильная версия",
                    "Семантическое ядро: 300–600 запросов на узбекском и русском",
                    "Разбор 5 основных конкурентов",
                    "Конкретные рекомендации по структуре сайта",
                    "Техническое задание на контент",
                    "Список задач, отсортированный по приоритету",
                    "Часовая встреча с разбором отчёта",
                ],
            },
            {
                name: "Постоянное SEO",
                tagline: "Ежемесячная работа и устойчивый рост",
                price: "6 000 000 сум",
                priceNote: "в месяц, минимум 6 месяцев",
                term: "Абонентская плата",
                best: "Среднему бизнесу, которому нужен постоянный поток заявок из поиска",
                featured: true,
                features: [
                    "Все работы пакета «Аудит» в первый месяц",
                    "Поэтапное исправление технических ошибок",
                    "4–6 текстов страниц или статей в месяц",
                    "Постоянная работа с метатегами, заголовками и перелинковкой",
                    "Оптимизация Core Web Vitals",
                    "Разметка Schema.org и расширенные сниппеты",
                    "Связка с профилем Google Business",
                    "Настройка и контроль Яндекс.Вебмастера",
                    "Ежемесячный отчёт: позиции, трафик, количество заявок",
                ],
            },
            {
                name: "Комплекс",
                tagline: "SEO + контент + внешний вес",
                price: "12 000 000 сум",
                priceNote: "в месяц, минимум 6 месяцев",
                term: "Абонентская плата",
                best: "Высококонкурентным нишам, большим каталогам и мультиязычным сайтам",
                features: [
                    "Все работы пакета «Постоянное SEO»",
                    "10–14 текстов в месяц и расширенный контент-план",
                    "Работа с внешними ссылками и упоминаниями компании",
                    "Массовая оптимизация страниц больших каталогов",
                    "Трёхъязычное SEO (uz / ru / en) и схема hreflang",
                    "Анализ конверсии: превращается ли трафик в заявки",
                    "Ежемесячный мониторинг конкурентов",
                    "Персональный SEO-менеджер и созвоны раз в неделю",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Процесс",
        h: "Как ведётся SEO-оптимизация",
        sub: "Первые сдвиги — через 2–3 месяца, заметный рост — через 5–9. Тем, кто обещает быстрее, верить не стоит.",
        steps: [
            {
                t: "Бесплатный первичный аудит",
                time: "3–5 дней",
                d: "Проверяем техническое состояние сайта, текущие позиции и конкурентов. Вы получаете список проблем и предварительный план без обязательств.",
            },
            {
                t: "Семантическое ядро",
                time: "1–2 недели",
                d: "Выясняем, что именно набирают люди. Запросы собираются на двух языках, делятся по интенту и распределяются по страницам.",
            },
            {
                t: "Технические исправления",
                time: "2–6 недель",
                d: "Индексация, скорость, мобильная версия, дубли, разметка. Без этого этапа эффект от всех последующих работ падает вдвое.",
            },
            {
                t: "Страницы и контент",
                time: "постоянно",
                d: "Существующие тексты переписываются, добавляются новые страницы и статьи. Каждая работает под своей группой запросов.",
            },
            {
                t: "Локальные сигналы",
                time: "2–4 недели",
                d: "Приводим в порядок профиль Google Business, данные на карте, единообразие NAP и записи в локальных каталогах.",
            },
            {
                t: "Внешний вес",
                time: "постоянно",
                d: "Получаем ссылки с качественных площадок и наращиваем упоминания компании. Дешёвые покупные ссылки не используются.",
            },
            {
                t: "Замеры и корректировка",
                time: "ежемесячно",
                d: "Сравниваем позиции, трафик и количество заявок. Неработающие гипотезы убираются, работающие масштабируются.",
            },
        ],
    },
    samples: {
        eyebrow: "Примеры",
        h: "Сайты, подготовленные нами под поиск",
        sub: "Эти проекты изначально строились с учётом требований поисковых систем.",
        cta: "Смотреть все проекты",
        slugs: ["mountain-and-sea", "global-building-group", "ipsum-pathology", "cleanza"],
    },
    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы про SEO",
        sub: "Прямые ответы на то, что спрашивают чаще всего.",
        items: [
            {
                q: "Сколько стоит SEO-оптимизация?",
                a: "В Innobek разовый аудит стоит 3 500 000 сум, постоянное SEO — от 6 000 000 сум в месяц, комплексный пакет — от 12 000 000 сум. Точная сумма зависит от размера сайта, конкуренции в нише и нужного объёма контента. Продвижение сайта-визитки и каталога на 5000 товаров различается по трудозатратам в десятки раз.",
            },
            {
                q: "Через сколько виден результат SEO?",
                a: "Первые сдвиги — через 2–3 месяца: улучшаются технические показатели, появляются позиции по низкоконкурентным запросам. Заметный рост трафика приходит в интервале 5–9 месяцев. В конкурентных нишах срок растягивается до года. Если в первый месяц позиции не меняются, это нормально.",
            },
            {
                q: "Вы гарантируете первое место?",
                a: "Нет. И держитесь подальше от любой компании, которая такое гарантирует. Алгоритмом ранжирования Google не управляет ни одно агентство. Мы гарантируем объём работ, их качество и открытые цифры каждый месяц. Практическая цель формулируется так: «выйти в топ-10 по этим 25 запросам к шестому месяцу».",
            },
            {
                q: "Можно ли попасть в топ за один месяц?",
                a: "Практически никогда. Исключение — сверхузкие запросы с нулевой конкуренцией, например название вашей собственной компании. По реальным коммерческим запросам месяца не хватит даже на формирование доверия Google к сайту. Агентство, обещающее такое, либо лжёт, либо загонит сайт под фильтр рискованными методами.",
            },
            {
                q: "Продвигаться на узбекском или на русском?",
                a: "На обоих. В Узбекистане одну и ту же услугу ищут на двух языках, и соотношение резко отличается по нишам. В медицине и образовании больше узбекоязычных запросов, в IT и B2B преобладают русскоязычные. Работать только с одним языком — значит подарить половину трафика конкурентам.",
            },
            {
                q: "Вы работаете с Яндексом?",
                a: "Да. В Узбекистане доминирует Google, но в отдельных нишах и среди русскоязычной аудитории доля Яндекса всё ещё заметна. Мы настраиваем Яндекс.Вебмастер, отправляем карту сайта и следим за ошибками индексации. Хорошая новость: большая часть технических и контентных работ приносит пользу обеим системам сразу.",
            },
            {
                q: "Если есть реклама, SEO не нужно?",
                a: "Они не заменяют, а дополняют друг друга. Google Ads даёт заявки уже сегодня, но останавливается вместе с бюджетом. SEO стартует медленно, зато после шестого месяца ощутимо снижает стоимость заявки. Многие наши клиенты начинают с рекламы, параллельно ведут SEO и со временем сокращают рекламный бюджет.",
            },
            {
                q: "У меня новый сайт — есть ли смысл в SEO?",
                a: "Да, и это самый подходящий момент. Правильно заложить структуру, схему URL и техническую основу с нуля значительно дешевле, чем переделывать позже. Единственный минус — результат придёт чуть позже, так как на формирование доверия Google к новому домену уходит обычно 3–6 месяцев.",
            },
            {
                q: "Кто пишет контент?",
                a: "Возможны три схемы: пишем мы, пишете вы или работаем вместе. На практике лучший результат даёт третий вариант — экспертиза, факты и реальные примеры от вас, структура и соответствие требованиям поиска от нас. Каждый текст отправляется вам на согласование до публикации: вы вносите правки, и только после этого материал появляется на сайте.",
            },
            {
                q: "Если я прекращу договор, позиции пропадут?",
                a: "Не сразу. Вся выполненная работа остаётся на вашем сайте: контент, технические исправления, разметка Schema.org и полученные ссылки принадлежат вам и никуда не исчезают. Но конкуренты не останавливаются, а алгоритмы Google регулярно обновляются, поэтому в течение 4–8 месяцев позиции могут постепенно проседать. Скорость просадки зависит от конкуренции в нише.",
            },
            {
                q: "Бесплатный аудит действительно бесплатный?",
                a: "Первичный — да, действительно бесплатный. В него входят основные технические проблемы сайта, предварительный список запросов и общий план, всё без каких-либо обязательств. Полный аудит за 3 500 000 сум значительно глубже: собранное семантическое ядро, разбор пяти конкурентов и готовое техническое задание, по которому может работать ваш разработчик.",
            },
        ],
    },
    cta: {
        h: "Где ваш сайт находится в Google прямо сейчас?",
        p: "На бесплатном аудите покажем текущее положение, назовём запросы, по которым реально выйти в топ, и дадим план со сроками. Лишних обещаний не даём.",
        button: "Получить бесплатный SEO-аудит",
        secondary: "+998 90 954 12 62",
    },
    images: [
        {
            src: "/assets/img/blog/web-seo.webp",
            alt: "Результат поиска Google и показатели PageSpeed — итог SEO-оптимизации сайта",
            caption: "Позиция в выдаче и скорость сайта связаны напрямую: медленный сайт в топ не выходит.",
        },
        {
            src: "/assets/img/services/seo-semantika.webp",
            alt: "Таблица ключевых слов на узбекском и русском — этап сбора семантического ядра",
            caption: "Семантическое ядро собирается на двух языках и группируется по интенту запроса.",
            prompt:
                "Clean desktop screenshot-style illustration of a keyword research spreadsheet with two language columns (Uzbek Latin and Russian Cyrillic), search volume and difficulty columns, soft blue accent highlights, light UI, no logos, high detail, 16:9",
        },
        {
            src: "/assets/img/services/seo-texnik-audit.webp",
            alt: "Технический SEO-аудит сайта: ошибки индексации и отчёт Core Web Vitals",
            caption: "Технический аудит — обязательный этап перед написанием контента.",
            prompt:
                "Modern analytics dashboard showing technical SEO audit results: crawl errors list, indexation chart, Core Web Vitals gauges for LCP INP CLS in green and amber, minimal light interface, no brand logos, 16:9",
        },
        {
            src: "/assets/img/services/seo-osish-grafigi.webp",
            alt: "График роста органического трафика за шесть месяцев — динамика результата SEO",
            caption: "Типичная динамика: первые два месяца ровная линия, затем постепенный подъём.",
            prompt:
                "Line chart of organic search traffic growth over nine months, flat for the first two months then rising steadily, clean minimal analytics UI, blue gradient fill, month labels, no logos, 16:9",
        },
    ],
    related: ["google-ads", "google-business", "korporativ-saytlar", "internet-dokonlar"],
};

const content = { uz, ru };

export default content;
